import { Button } from "src/ui/widgets";

import { usePaymentKo } from "./payment-ko.hook";
import { LeftArrowIcon, WarningIcon } from "src/assets";
import { Image } from "react-bootstrap";

export const PaymentKo = () => {
  const { t, goToDataEntry } = usePaymentKo();

  return (
    <div className="payment-result-container">
      <div className="mb-3 d-flex flex-column flex-md-row align-items-center align-items-md-start">
        <Image
          src={WarningIcon}
          className="filter-F34747 mt-sm-2"
          width={48}
          height={48}
        />

        <div className="ms-3 title">{t("payment.failure_title")}</div>
      </div>
      <div className="body">
        <div>{t("payment.error_subtitle_1")}</div>
        <div>{t("payment.error_subtitle_2")}</div>
      </div>

      <div className="buttons-container">
        <Button
          text={t("payment.go_back_itasgive")}
          iconLeft={LeftArrowIcon}
          classes="m-0 p-0"
          flavor="transparentAccentBack"
          classesIconLeft="filter-00686F me-2"
          onPress={goToDataEntry}
        />
      </div>
    </div>
  );
};
